import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero min-h-screen flex items-center" id="home">
      <div className="container mx-auto px-8">
        <div className="hero-content ml-auto">
          <h6 className="intro-text mb-4 text-[#00e5e8]">Hi, my name is</h6>
          <div className="name-container mb-6">
            <h1 className="name-heading">
              <span className="name-text">Vikas</span>&nbsp;
              <span className="name-text">Pawar</span>
            </h1>
          </div>
          <div className="about-text max-w-2xl mb-12">
            <p className="text-[#8892b0] text-2xl leading-relaxed tracking-wide">
              Versatile full-stack developer proficient in Java.
              <br />
              Strong in data structures and modern frameworks.
              <br />
              Passionate about efficient solutions and collaborative innovation.
            </p>
          </div>
          <div className="cta-buttons flex gap-6">
            <a
              href={process.env.PUBLIC_URL + "/VikasPawar.pdf"}
              className="primary-btn glowText text-lg px-8 py-4 font-medium tracking-wide"
              download="VikasPawar"
            >
              Download CV
            </a>
            <a
              href="#contact"
              className="secondary-btn glowText text-lg px-8 py-4 font-medium tracking-wide"
            >
              Get In Touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
